var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossv2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 16.1942L9.06678 10.1274L3.00002 4.06066L4.06068 3L10.1274 9.06676L16.1942 3L17.2549 4.06066L11.1881 10.1274L17.2549 16.1942L16.1942 17.2549L10.1274 11.1881L4.06066 17.2549L3 16.1942Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossv2);
export default __webpack_public_path__ + "static/media/crossv2.c87ca86045181c83cc224e361b125d4b.svg";
export { ForwardRef as ReactComponent };